<template>
  <v-container fluid>
    <v-sheet v-if="!!editor" class="px-0 py-0 mx-0 my-0">
      <v-sheet v-if="showToolBar === true" dense elevation="0" class="px-0 py-0 mx-0 my-0">
        <v-row no-gutters>
<!--          <v-col cola="12" class="my-0">-->
            <v-chip small class="mx-1 px-1" label>
              <v-btn small icon @click="editor.chain().focus().toggleBold().run()"
                     :disabled="!editor.can().chain().focus().toggleBold().run()"
                     :class="{ 'is-active': editor.isActive('bold') }">
                <v-icon small>mdi-format-bold</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().toggleItalic().run()"
                     :disabled="!editor.can().chain().focus().toggleItalic().run()"
                     :class="{ 'is-active': editor.isActive('italic') }">
                <v-icon small>mdi-format-italic</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().toggleStrike().run()"
                     :disabled="!editor.can().chain().focus().toggleStrike().run()"
                     :class="{ 'is-active': editor.isActive('strike') }">
                <v-icon x-small>mdi-format-strikethrough-variant</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().toggleUnderline().run()"
                     :disabled="!editor.can().chain().focus().toggleUnderline().run()"
                     :class="{ 'is-active': editor.isActive('underline') }">
                <v-icon small>mdi-format-underline</v-icon>
              </v-btn>
            </v-chip>
            <v-chip small class="mx-1 px-1" label>
              <v-btn small icon @click="editor.chain().focus().setColor(textColor).run()"
                     :class="{ 'is-active': editor.isActive('textStyle', { color: textColor }) }"
                     :color="textColor"
              >
                <v-icon small>mdi-format-color-text</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().unsetColor().run()"
                     :disabled="!editor.isActive('textStyle')">
                <v-icon small>mdi-format-color-marker-cancel</v-icon>
              </v-btn>
              <v-edit-dialog
                  :return-value.sync="textColor"
                  large
              >
                <v-btn small icon :color="textColor">
                  <v-icon small>mdi-palette-outline</v-icon>
                </v-btn>
                <template v-slot:input>
                  <v-card>
                    <v-color-picker
                        v-model="textColor"
                        mode="hexa"
                        swatches-max-height="200"
                        dot-size="14"
                        hide-canvas
                        hide-inputs
                        hide-mode-switch
                        hide-sliders
                        show-swatches
                        class="mt-5"
                    ></v-color-picker>
                  </v-card>
                </template>
              </v-edit-dialog>
            </v-chip>
            <v-chip small class="mx-1 px-1" label>
              <v-btn small icon @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
                     :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }">
                <v-icon small>mdi-format-header-1</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
                     :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }">
                <v-icon small>mdi-format-header-2</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
                     :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }">
                <v-icon small>mdi-format-header-3</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().toggleHeading({ level: 4 }).run()"
                     :class="{ 'is-active': editor.isActive('heading', { level: 4 }) }">
                <v-icon small>mdi-format-header-4</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().toggleHeading({ level: 5 }).run()"
                     :class="{ 'is-active': editor.isActive('heading', { level: 5 }) }">
                <v-icon small>mdi-format-header-5</v-icon>
              </v-btn>
            </v-chip>
            <v-chip small class="mx-1 px-1" label>
              <v-btn small icon @click="editor.chain().focus().setTextAlign('left').run()"
                     :class="{ 'is-active': editor.isActive({ textAlign: 'left' }) }">
                <v-icon small>mdi-format-align-left</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().setTextAlign('center').run()"
                     :class="{ 'is-active': editor.isActive({ textAlign: 'center' }) }">
                <v-icon small>mdi-format-align-center</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().setTextAlign('right').run()"
                     :class="{ 'is-active': editor.isActive({ textAlign: 'right' }) }">
                <v-icon small>mdi-format-align-right</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().setTextAlign('justify').run()"
                     :class="{ 'is-active': editor.isActive({ textAlign: 'justify' }) }">
                <v-icon small>mdi-format-align-justify</v-icon>
              </v-btn>
            </v-chip>
            <v-chip small class="mx-1 px-1" label>
              <v-btn small icon @click="editor.chain().focus().toggleBulletList().run()"
                     :class="{ 'is-active': editor.isActive('bulletList') }">
                <v-icon small>mdi-format-list-bulleted</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().toggleOrderedList().run()"
                     :class="{ 'is-active': editor.isActive('orderedList') }">
                <v-icon small>mdi-format-list-numbered</v-icon>
              </v-btn>
            </v-chip>
            <v-chip small class="mx-1 px-1" label>
              <v-btn small icon @click="editor.chain().focus().toggleHighlight({ color: highlightColor }).run()"
                     :class="{ 'is-active': editor.isActive('highlight', { color: highlightColor }) }"
              >
                <v-icon small>mdi-format-color-highlight</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().unsetHighlight().run()"
                     :disabled="!editor.isActive('highlight')">
                <v-icon small>mdi-format-color-marker-cancel</v-icon>
              </v-btn>
              <v-edit-dialog
                  :return-value.sync="highlightColor"
                  large
              >
                <v-btn small icon :color="highlightColor">
                  <v-icon small>mdi-palette-outline</v-icon>
                </v-btn>
                <template v-slot:input>
                  <v-card>
                    <v-color-picker
                        v-model="highlightColor"
                        mode="hexa"
                        swatches-max-height="200"
                        dot-size="14"
                        hide-canvas
                        hide-inputs
                        hide-mode-switch
                        hide-sliders
                        show-swatches
                        class="mt-5"
                    ></v-color-picker>
                  </v-card>
                </template>
              </v-edit-dialog>
            </v-chip>
            <v-chip small class="mx-1 px-1" label>
              <v-btn small icon @click="editor.chain().focus().toggleCodeBlock().run()"
                     :class="{ 'is-active': editor.isActive('codeBlock') }">
                <v-icon small>mdi-code-braces</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().toggleBlockquote().run()"
                     :class="{ 'is-active': editor.isActive('blockquote') }">
                <v-icon small icon>mdi-format-quote-close-outline</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().setHorizontalRule().run()">
                <v-icon small icon>mdi-minus</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().setHardBreak().run()">
                <v-icon small icon>mdi-format-page-break</v-icon>
              </v-btn>
            </v-chip>
            <!--        Link Image Video -->
            <v-chip small class="mx-1 px-1" label>
              <!--          Link-->
              <v-edit-dialog
                  :return-value.sync="linkURL"
                  large
                  @save="setLink(linkURL)"
              >
                <v-btn small icon :class="{ 'is-active': editor.isActive('link') }">
                  <v-icon small icon>mdi-link</v-icon>
                </v-btn>
                <template v-slot:input>
                  <v-sheet width="600">
                    <v-text-field
                        v-model="linkURL"
                        dense
                        outlined
                        class="mt-3"
                        label="link"
                    >
                    </v-text-field>
                    <small>link: {{ editor.getAttributes('link').href }}</small>
                  </v-sheet>
                </template>
              </v-edit-dialog>
              <v-btn small icon @click="editor.chain().focus().unsetLink().run()" :disabled="!editor.isActive('link')">
                <v-icon small icon>mdi-link-off</v-icon>
              </v-btn>
              <!--          Image-->
              <LibraryFileNewDialog v-model="imageURL" @input="saveImage()"
                                    icon="mdi-image-area"></LibraryFileNewDialog>
              <!--          Video-->
              <LibraryVideoNewDialog v-model="videoURL" @input="saveVideo()" icon="mdi-vimeo"></LibraryVideoNewDialog>
            </v-chip>
            <v-chip small class="mx-1 px-1" label>
              <v-btn small icon
                     @click="editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()">
                <v-icon small>mdi-table-plus</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().addColumnBefore().run()">
                <v-icon small>mdi-table-column-plus-before</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().addColumnAfter().run()">
                <v-icon small>mdi-table-column-plus-after</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().deleteColumn().run()">
                <v-icon small>mdi-table-column-remove</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().addRowBefore().run()">
                <v-icon small>mdi-table-row-plus-before</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().addRowAfter().run()">
                <v-icon small>mdi-table-row-plus-after</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().deleteRow().run()">
                <v-icon small>mdi-table-row-remove</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().deleteTable().run()">
                <v-icon small>mdi-table-remove</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().mergeCells().run()">
                <v-icon small>mdi-table-merge-cells</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().splitCell().run()">
                <v-icon small>mdi-table-split-cell</v-icon>
              </v-btn>
              <!--          <v-btn small icon @click="editor.chain().focus().toggleHeaderColumn().run()">-->
              <!--            <v-icon small>mdi-table-split-cell</v-icon>-->
              <!--          </v-btn>-->
              <!--          <v-btn small icon  @click="editor.chain().focus().toggleHeaderRow().run()">-->
              <!--            toggleHeaderRow-->
              <!--          </v-btn>-->
              <!--          <v-btn small icon  @click="editor.chain().focus().toggleHeaderCell().run()">-->
              <!--            toggleHeaderCell-->
              <!--          </v-btn>-->
              <!--          <v-btn small icon  @click="editor.chain().focus().mergeOrSplit().run()">-->
              <!--            mergeOrSplit-->
              <!--          </v-btn>-->
              <!--          <v-btn small icon  @click="editor.chain().focus().setCellAttribute('colspan', 2).run()">-->
              <!--            setCellAttribute-->
              <!--          </v-btn>-->
              <!--          <v-btn small icon  @click="editor.chain().focus().fixTables().run()">-->
              <!--            fixTables-->
              <!--          </v-btn>-->
              <!--          <v-btn small icon  @click="editor.chain().focus().goToNextCell().run()">-->
              <!--            goToNextCell-->
              <!--          </v-btn>-->
              <!--          <v-btn small icon  @click="editor.chain().focus().goToPreviousCell().run()">-->
              <!--            goToPreviousCell-->
              <!--          </v-btn>-->
            </v-chip>
            <v-chip small class="mx-1 px-1" label>
              <v-btn small icon @click="editor.chain().focus().clearNodes().run()">
                <v-icon small>mdi-format-clear</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().undo().run()"
                     :disabled="!editor.can().chain().focus().undo().run()">
                <v-icon small icon>mdi-undo</v-icon>
              </v-btn>
              <v-btn small icon @click="editor.chain().focus().redo().run()"
                     :disabled="!editor.can().chain().focus().redo().run()">
                <v-icon small>mdi-redo</v-icon>
              </v-btn>
            </v-chip>
            <v-spacer></v-spacer>
            <slot name="bar.end">
            </slot>
<!--          </v-col>-->
        </v-row>
      </v-sheet>
      <v-sheet v-if="height !== null" :height="height" class="mt-2 overflow-y-auto">
        <editor-content :editor="editor" disabled="true" class="editor-tiptap"/>
      </v-sheet>
      <v-sheet v-else>
        <editor-content :editor="editor" disabled="true" ref="editorRef" class="editor-tiptap"/>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
import {Editor, EditorContent} from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import ResizableImage from './resizable-image.js';
import EmbedMedia from './embed-media.js'
import Underline from '@tiptap/extension-underline'
import TextAlign from "@tiptap/extension-text-align";
import TextStyle from '@tiptap/extension-text-style'
import Highlight from "@tiptap/extension-highlight";
import Blockquote from "@tiptap/extension-blockquote"
import Link from "@tiptap/extension-link"
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Gapcursor from '@tiptap/extension-gapcursor'
import Table from '@tiptap/extension-table'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'
import Text from '@tiptap/extension-text'
import {Color} from '@tiptap/extension-color'
import {v4 as uuidv4} from 'uuid'
import {mapFields} from "vuex-map-fields";
import LibraryFileNewDialog from "@/components/LibraryDoc/LibraryFile/LibraryFileNewDialog";
import LibraryVideoNewDialog from "@/components/LibraryDoc/LibraryFile/LibraryVideoNewDialog";

export default {
  name: "TipTapEditor",
  components: {
    EditorContent,
    LibraryFileNewDialog,
    LibraryVideoNewDialog,
  },
  props: {
    value: {type: Object, default: null,},
    showToolBar: {type: [Boolean], default: false},
    readonly: {type: [Boolean], default: false},
    height: {type: [Number], default: null},
  },
  computed: {
    ...mapFields('LibraryFileTable', ['editedItem']),

    showButton() {
      return this.editor?.state?.selection?.node?.type?.name === 'ResizableImage';
    },
    isDraggable() {
      return this.editor?.state?.selection?.node?.attrs?.isDraggable;
    },
  },

  watch: {
    value: {
      handler(newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          // console.log('TipTap watch', JSON.stringify(newValue), JSON.stringify(oldValue), this.editor.getJSON())
          const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(newValue);
          if (isSame) {
            // console.log('TipTap watch. The same')
            return;
          }
          // console.log('TipTap watch setContent', JSON.stringify(newValue))
          this.editor.commands.setContent(newValue, false);
        }
      },
      deep: true
    },
  }
  ,
  mounted() {
    const self = this
    this.editor = new Editor({
      content: this.value,
      editable: !this.readonly,
      autofocus: true,
      extensions: [
        StarterKit,
        ResizableImage.configure({
          inline: true,
          ref: self,
        }),
        EmbedMedia.configure({
          inline: true
        }),
        Underline,
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
        Highlight.configure({
          multicolor: true,
        }),
        Link.configure({
          openOnClick: true,
          linkOnPaste: true,
        }),
        Blockquote.configure({
          HTMLAttributes: {
            class: 'blockquote',
          },
        }),
        TextStyle,
        Color,
        Document,
        Paragraph,
        Text,
        Gapcursor,
        Table.configure({
          resizable: true,
        }),
        TableRow,
        TableHeader,
        TableCell,
      ],
      onUpdate: () => {
        // console.log('onUpdate')
        this.$emit('input', this.editor.getJSON());
      },
    });
  }
  ,
  methods: {
    toggleResize() {
      this.editor.chain().focus().toggleResizable().run();
    }
    ,
    setLink(linkURL) {
      const previousUrl = this.editor.getAttributes('link').href
      // const url = window.prompt('URL', previousUrl)

      // cancelled
      if (linkURL === null) {
        return
      }

      // empty
      if (linkURL === '') {
        this.editor.chain().focus().extendMarkRange('link').unsetLink().run()
        return
      }
      // update link
      this.editor.chain().focus().extendMarkRange('link').setLink({href: linkURL}).run()
    }
    ,
    saveImage() {
      // console.log('saveImage', this.editor.chain().focus())
      this.editor.chain().focus().setImage({src: this.imageURL, width: 200}).toggleResizable().run()
    },

    saveVideo() {
      // console.log('saveImage', this.editor.chain().focus())
      this.editor.chain().focus().setEmbedVideo({src: this.videoURL, height: 300, width: 530}).run()
    }
    ,
    addVimeo() {
    }
    ,
  }
  ,

  data() {
    return {
      editor: null,
      highlightColor: '#FFEB3B',
      textColor: '#000000',
      linkURL: null,
      imageURL: null,
      videoURL: null,
    };
  }
  ,

  beforeDestroy() {
    this.editor.destroy();
  }
}
;
</script>
<style scoped>

.editor-tiptap >>> .ProseMirror {
  outline: 0px solid #bcbfc4;
  min-height: 10px;
}

.editor-tiptap >>> .ProseMirror tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .0);
}

.editor-tiptap >>> .ProseMirror table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 0;
  overflow: hidden;
}

.editor-tiptap >>> .ProseMirror td, th {
  min-width: 1em;
  border: 1px solid #ced4da;
  padding: 3px 5px;
  vertical-align: top;
  box-sizing: border-box;
  position: relative;
}


.editor-tiptap >>> .ProseMirror th {
  border: 1px solid #ced4da;
  font-weight: bold;
  text-align: left;
  background-color: #f1f3f5;
}

.editor-tiptap >>> .ProseMirror .selectedCell:after {
  z-index: 2;
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(200, 200, 255, 0.4);
  pointer-events: none;
}

.editor-tiptap >>> .ProseMirror .column-resize-handle {
  position: absolute;
  right: -2px;
  top: 0;
  bottom: -2px;
  width: 4px;
  background-color: #adf;
  pointer-events: none;
}

.v-application p {
  margin-bottom: 0px !important;
}


</style>